var exports = {
  "x6": "TextareaButton.module__button___eFY4V0",
  "DY": "TextareaButton.module__contextMenuHover___eFY4V0",
  "wH": "TextareaButton.module__selected___eFY4V0",
  "Kk": "TextareaButton.module__icon___eFY4V0",
  "w": "TextareaButton.module__buttonCompact___eFY4V0" + " " + "TextareaButton.module__button___eFY4V0",
};

module.exports = exports;
